<ng-container *ngIf="title?.length">
  <app-section-header *ngIf="header" [title]="title"></app-section-header>
  <app-label-value *ngIf="!header" [label]="title" [noValue]="true"></app-label-value>
</ng-container>
<!-- Extra info or content between title and values -->
<ng-content></ng-content>
<!-- Translations -->
<mat-tab-group mat-align-tabs="left" class="tabs max-width" *ngIf="hasValues">
  <ng-container *ngFor="let translation of translationValues">
    <mat-tab *ngIf="translation?.value?.length" [label]="('general.api_translations_table_lang_' + translation.language) | translate">
      <app-html-more *ngIf="htmlValues" [html]="translation.value"></app-html-more>
      <app-read-more *ngIf="!htmlValues" [text]="translation.value" [maxLength]="200"></app-read-more>
    </mat-tab>
  </ng-container>
</mat-tab-group>
<div *ngIf="!hasValues" class="top-spacer">
  <app-info-message [message]="title?.length ? (title + '_empty') : 'general.api_general_translations_empty'"></app-info-message>
</div>
